
import React from 'react'
import { BaseModal } from '@shared/components/atoms/BaseModal'
import ineditosLogo from '@site/images/ineditos/logo_ineditos-white.svg'
import curadoriaLogo from '@site/images/curadoria/logo_curadoria-white.svg'
import closeIcon from '@shared/images/close-circle.svg'
import * as S from './SubscribeModal.style.js'
import useSubscriptionPlans from '@site/hooks/useSubscriptionPlans'
import * as PathNavigation from '@site/components/PathNavigation.js'
import PropTypes from 'prop-types'
import { graphql, useStaticQuery } from 'gatsby'

const themeByCategory = {
  'ineditos': {
    'color': 'INE-300',
    'logo': ineditosLogo,
  },
  'curadoria': {
    'color': 'CUR-400',
    'logo': curadoriaLogo,
  }
}

export const SubscribeModal = ( { shouldDisplay, setShouldDisplay } ) => {
  const subscriptionPlans = useSubscriptionPlans()
  const getMonthlyPriceFromPlan = ( planId ) => {
    return subscriptionPlans.find( plan => plan.id === planId ).pricePerKit.toString().replace( '.', ',' ).padEnd( 5, 0 )
  }

  const { 'allStrapiGifts': { nodes } } = useStaticQuery( graphql`
    query {
      allStrapiGifts(limit: 1, sort: {order: DESC, fields: strapiId}) {
        nodes {
          ineditos {
            title
          }
          curadoria {
            title
          }
        }
      }
    }
  ` )
  const [ gifts ] = nodes

  return (
    <BaseModal
      shouldDisplay={ shouldDisplay }
      onClickBackdrop={ () => setShouldDisplay( false ) }
    >
      <S.Container>
        <S.CloseIconBackground
          onClick={ () => setShouldDisplay( false ) }
        >
          <S.CloseIcon
            alt="Close icon"
            src={ closeIcon }
          />
        </S.CloseIconBackground>
        <CardOffer
          category="ineditos"
          yearlyPrice={ getMonthlyPriceFromPlan( 6 ) }
          monthlyOffer={ `R$${getMonthlyPriceFromPlan( 4 )}/MÊS + FRETE` }
          gifts={ gifts }
        />
        <CardOffer
          category="curadoria"
          yearlyPrice={ getMonthlyPriceFromPlan( 3 ) }
          monthlyOffer={ `R$${getMonthlyPriceFromPlan( 1 )}/MÊS + FRETE` }
          gifts={ gifts }
        />
      </S.Container>
    </BaseModal>
  )
}

const CardOffer = ( { category, yearlyPrice, monthlyOffer, gifts } ) => {
  const gift = gifts[ category ]
  return (
    <S.CardOffer
      themeColor={ themeByCategory[ category ].color }
    >
      <S.LogoImage
        alt={ 'Logo ' + category }
        src={ themeByCategory[ category ].logo }
      />
      <PriceDisplay price={ yearlyPrice } />
      <S.InfoGift>
        { gift.title }
      </S.InfoGift>
      <S.ActionButton href={ getSubscribeLink( category, 'anual' ) }>
        ASSINAR ANUAL
      </S.ActionButton>
      <S.InfoPrice>
        { monthlyOffer }
      </S.InfoPrice>
      <S.ActionButtonInverted href={ getSubscribeLink( category, 'mensal' ) }>
        ASSINAR MENSAL
      </S.ActionButtonInverted>
    </S.CardOffer>
  )
}

const getSubscribeLink = ( category, plan ) => {
  const productUrl = {
    'curadoria': {
      'anual': `&product=yearlyCuradoria`,
      'mensal': `&product=monthlyCuradoria`,
    },
    'ineditos': {
      'anual': `&product=yearlyIneditos`,
      'mensal': `&product=monthlyIneditos`,
    }
  }[ category ][ plan ]
  return `${PathNavigation.onePageCheckout}?partnerCode=${PathNavigation.sitePartnerCode}${productUrl}`
}

const PriceDisplay = ( { price } ) => (
  <S.PriceDisplay>
    <S.PriceDisplayAt>
      por
    </S.PriceDisplayAt>
    <S.PriceDisplayValue>
      { price }
    </S.PriceDisplayValue>
    <S.PriceDisplayMonth>
      /mês + frete
    </S.PriceDisplayMonth>
  </S.PriceDisplay>
)

SubscribeModal.propTypes = {
  'setShouldDisplay': PropTypes.func.isRequired,
  'shouldDisplay': PropTypes.bool.isRequired,
}

CardOffer.propTypes = {
  'category': PropTypes.string.isRequired,
  'gifts': PropTypes.object.isRequired,
  'monthlyOffer': PropTypes.string.isRequired,
  'yearlyPrice': PropTypes.string.isRequired,
}

PriceDisplay.propTypes = {
  'price': PropTypes.string.isRequired
}
